declare namespace $ {

	type $mol_view__sub_shm_projects_page_1 = $mol_type_enforce<
		ReturnType< $shm_projects_page['menu_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_projects_page_2 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_4 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_description'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_5 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_problem'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_7 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_problem'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_8 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_audience'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_10 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_audience'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_11 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_13 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_value'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_14 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_scenarios'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_16 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_scenarios'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_page_17 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_success'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_page_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_19 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_success'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__value_shm_projects_page_20 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_stage'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_projects_page_21 = $mol_type_enforce<
		({ 
			'idea': string,
			'prototype': string,
			'mvp': string,
			'growing': string,
			'support': string,
			'archived': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_form_field__name_shm_projects_page_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_page_23 = $mol_type_enforce<
		ReturnType< $shm_projects_page['Product_stage'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form__form_fields_shm_projects_page_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__submit_title_shm_projects_page_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['submit_title'] >
	>
	type $mol_form__message_done_shm_projects_page_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form['message_done'] >
	>
	type $mol_form__save_shm_projects_page_27 = $mol_type_enforce<
		ReturnType< $shm_projects_page['product_save'] >
		,
		ReturnType< $mol_form['save'] >
	>
	type $mol_textarea__hint_shm_projects_page_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_projects_page_29 = $mol_type_enforce<
		ReturnType< $shm_projects_page['draft_note'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_shm_projects_page_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_32 = $mol_type_enforce<
		ReturnType< $shm_projects_page['module_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_shm_projects_page_33 = $mol_type_enforce<
		ReturnType< $shm_projects_page['module_readme_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_shm_projects_page_34 = $mol_type_enforce<
		ReturnType< $shm_projects_page['dependency_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_36 = $mol_type_enforce<
		ReturnType< $shm_projects_page['dependency_commits_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_39 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_40 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_mode_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_41 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_selected_date'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_42 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_action_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_43 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_stages_section_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_45 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_selected_requirements'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_48 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_51 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_test_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_54 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_check_list_only__options_shm_projects_page_57 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_line_ids'] >
		,
		ReturnType< $shm_check_list_only['options'] >
	>
	type $shm_check_list_only__value_shm_projects_page_58 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_lines_selected'] >
		,
		ReturnType< $shm_check_list_only['value'] >
	>
	type $shm_check_list_only__check_title_shm_projects_page_59 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_line_title'] >
		,
		ReturnType< $shm_check_list_only['check_title'] >
	>
	type $mol_pick__hint_shm_projects_page_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_projects_page_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_projects_page_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_projects_page_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_echarts__option_shm_projects_page_64 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_chart_option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $mol_view__sub_shm_projects_page_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_67 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_legend_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_check_list_only__inline_shm_projects_page_69 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_check_list_only['inline'] >
	>
	type $shm_check_list_only__only_visible_shm_projects_page_70 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_check_list_only['only_visible'] >
	>
	type $shm_check_list_only__options_shm_projects_page_71 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_file_ids'] >
		,
		ReturnType< $shm_check_list_only['options'] >
	>
	type $shm_check_list_only__value_shm_projects_page_72 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_files_selected'] >
		,
		ReturnType< $shm_check_list_only['value'] >
	>
	type $shm_check_list_only__check_title_shm_projects_page_73 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_file_title'] >
		,
		ReturnType< $shm_check_list_only['check_title'] >
	>
	type $mol_view__sub_shm_projects_page_74 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_projects_page_77 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_page['version_test_status_color'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_projects_page_78 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_79 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_82 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_table_header_cells'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_83 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_85 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_86 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_table_body_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_87 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_projects_page_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_shm_projects_page_91 = $mol_type_enforce<
		({ 
			'benchmark_change': ReturnType< $shm_projects_page['version_benchmark_table_cell_change'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_page_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_content_shm_projects_page_93 = $mol_type_enforce<
		ReturnType< $shm_projects_page['menu_title_rows'] >
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_page_94 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_string_button__value_shm_projects_page_95 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_projects_page_96 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_projects_page_97 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_projects_page['project_title_commit'] > ): ReturnType< $shm_projects_page['project_title_commit'] >,
			keydown( next?: ReturnType< $shm_projects_page['project_title_keydown'] > ): ReturnType< $shm_projects_page['project_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $shm_service_task_menu__remove_title_shm_projects_page_98 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_menu['remove_title'] >
	>
	type $shm_service_task_menu__remove_confirm_title_shm_projects_page_99 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_menu['remove_confirm_title'] >
	>
	type $shm_service_task_menu__remove_shm_projects_page_100 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_delete'] >
		,
		ReturnType< $shm_service_task_menu['remove'] >
	>
	type $mol_text__text_shm_projects_page_101 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link__arg_shm_projects_page_102 = $mol_type_enforce<
		ReturnType< $shm_projects_page['section_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_103 = $mol_type_enforce<
		ReturnType< $shm_projects_page['section_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_104 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_page__title_shm_projects_page_105 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_106 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_projects_configuration__project_id_shm_projects_page_107 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_configuration['project_id'] >
	>
	type $mol_page__title_shm_projects_page_108 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_109 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_projects_tasks__project_id_shm_projects_page_110 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_tasks['project_id'] >
	>
	type $shm_projects_codex_chat__project_id_shm_projects_page_111 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_codex_chat['project_id'] >
	>
	type $mol_view__attr_shm_projects_page_112 = $mol_type_enforce<
		({ 
			'status': ReturnType< $shm_projects_page['release_stage_status'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_page_113 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_docs__menu_title_shm_projects_page_114 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_docs['menu_title'] >
	>
	type $shm_projects_docs__readme_text_shm_projects_page_115 = $mol_type_enforce<
		ReturnType< $shm_projects_page['docs_readme_text'] >
		,
		ReturnType< $shm_projects_docs['readme_text'] >
	>
	type $shm_projects_docs__agents_text_shm_projects_page_116 = $mol_type_enforce<
		ReturnType< $shm_projects_page['docs_agents_text'] >
		,
		ReturnType< $shm_projects_docs['agents_text'] >
	>
	type $mol_page__title_shm_projects_page_117 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_118 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_119 = $mol_type_enforce<
		ReturnType< $shm_projects_page['module_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_120 = $mol_type_enforce<
		ReturnType< $shm_projects_page['module_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_121 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_122 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_projects_page_123 = $mol_type_enforce<
		ReturnType< $shm_projects_page['module_selected_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_projects_page_125 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_127 = $mol_type_enforce<
		ReturnType< $shm_projects_page['dependency_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_page_128 = $mol_type_enforce<
		ReturnType< $shm_projects_page['dependency_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_129 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_130 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_projects_page_131 = $mol_type_enforce<
		ReturnType< $shm_projects_page['dependency_selected_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_132 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_projects_tests__project_id_shm_projects_page_133 = $mol_type_enforce<
		ReturnType< $shm_projects_page['project_id'] >
		,
		ReturnType< $shm_projects_tests['project_id'] >
	>
	type $mol_page__title_shm_projects_page_134 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_page_135 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_136 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_off_shm_projects_page_137 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_uri'] >
		,
		ReturnType< $mol_link['uri_off'] >
	>
	type $mol_link__current_shm_projects_page_138 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_link_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_139 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_140 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_page__title_content_shm_projects_page_141 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_page_142 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_content'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_projects_page_143 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_result_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_144 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_result_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_145 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_projects_page_147 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmarks_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_148 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmarks_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_149 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_150 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_projects_page_151 = $mol_type_enforce<
		({ 
			'project_version_output': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_152 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_changes_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_153 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_154 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_projects_release_notes_view__notes_shm_projects_page_155 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_release_notes'] >
		,
		ReturnType< $shm_projects_release_notes_view['notes'] >
	>
	type $mol_link__arg_shm_projects_page_156 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_page_157 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_page_158 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_page_159 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_160 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_161 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_page_162 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_stage_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_page_163 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_164 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmarks_panel_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_165 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_166 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_167 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_168 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_169 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_info'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_shm_projects_page_170 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_page_171 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_run'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_projects_page_172 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_projects_page_173 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_page['version_benchmark_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $shm_projects_goal_chat__run_shm_projects_page_174 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_run'] >
		,
		ReturnType< $shm_projects_goal_chat['run'] >
	>
	type $shm_projects_goal_chat__iteration_shm_projects_page_175 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_iteration'] >
		,
		ReturnType< $shm_projects_goal_chat['iteration'] >
	>
	type $shm_projects_goal_chat__prerelease_shm_projects_page_176 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_prerelease'] >
		,
		ReturnType< $shm_projects_goal_chat['prerelease'] >
	>
	type $shm_projects_goal_chat__version_shm_projects_page_177 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_session_version'] >
		,
		ReturnType< $shm_projects_goal_chat['version'] >
	>
	type $mol_button_major__title_shm_projects_page_178 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_page_179 = $mol_type_enforce<
		ReturnType< $shm_projects_page['release_allowed'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_page_180 = $mol_type_enforce<
		ReturnType< $shm_projects_page['release_make'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_shm_projects_page_181 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_page_182 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_allowed'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_page_183 = $mol_type_enforce<
		ReturnType< $shm_projects_page['prerelease_activate'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_projects_page_184 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_release_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_projects_page_185 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_page['version_release_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_view__sub_shm_projects_page_186 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_187 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_page_188 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_page_189 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_screenshot_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_image_viewer__uri_shm_projects_page_190 = $mol_type_enforce<
		ReturnType< $shm_projects_page['change_screenshot_uri'] >
		,
		ReturnType< $shm_projects_image_viewer['uri'] >
	>
	type $mol_link__uri_shm_projects_page_191 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_test_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_192 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_projects_page_193 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_page_194 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_195 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_page_196 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_197 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_198 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_199 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_200 = $mol_type_enforce<
		ReturnType< $shm_projects_page['version_benchmark_table_row_cells'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_shm_projects_page_201 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_shm_projects_page_202 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_projects_page_203 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_page_204 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_shm_projects_page_205 = $mol_type_enforce<
		ReturnType< $shm_projects_page['other_artifact_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_projects_page_206 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_page extends $mol_book2 {
		project_pages( ): readonly(any)[]
		menu_title_rows( ): readonly(any)[]
		menu_rows( ): readonly(any)[]
		Menu( ): $mol_view
		project_title_draft( next?: string ): string
		project_title_commit( next?: any ): any
		project_title_keydown( next?: any ): any
		project_delete( next?: any ): any
		version_label( ): string
		section_arg( id: any): Record<string, any>
		section_title( id: any): string
		product_description( next?: string ): string
		Product_description( ): $mol_textarea
		Product_description_field( ): $mol_form_field
		product_problem( next?: string ): string
		Product_problem( ): $mol_textarea
		Product_problem_field( ): $mol_form_field
		product_audience( next?: string ): string
		Product_audience( ): $mol_textarea
		Product_audience_field( ): $mol_form_field
		product_value( next?: string ): string
		Product_value( ): $mol_textarea
		Product_value_field( ): $mol_form_field
		product_scenarios( next?: string ): string
		Product_scenarios( ): $mol_textarea
		Product_scenarios_field( ): $mol_form_field
		product_success( next?: string ): string
		Product_success( ): $mol_textarea
		Product_success_field( ): $mol_form_field
		product_stage( next?: string ): string
		Product_stage( ): $mol_select
		Product_stage_field( ): $mol_form_field
		product_save( next?: any ): any
		Product_form( ): $mol_form
		draft_note( next?: string ): string
		Draft( ): $mol_textarea
		release_stage_status( id: any): string
		Release_stage_marker( id: any): $mol_view
		release_stage_title( id: any): string
		Release_stage_title( id: any): $mol_view
		release_stage_elapsed( id: any): string
		Release_stage_elapsed( id: any): $mol_view
		docs_readme_text( ): string
		docs_agents_text( ): string
		module_rows( ): readonly(any)[]
		Modules( ): $mol_list
		module_arg( id: any): Record<string, any>
		module_title( id: any): string
		module_selected_title( ): string
		module_readme_text( ): string
		Module_readme( ): $mol_text
		dependency_rows( ): readonly(any)[]
		Dependencies( ): $mol_list
		dependency_arg( id: any): Record<string, any>
		dependency_title( id: any): string
		dependency_selected_title( ): string
		Dependency_type( ): $mol_view
		dependency_commits_text( ): string
		Dependency_commits( ): $mol_text
		dependency_behind_text( ): string
		Dependency_behind( ): $mol_view
		Dependency_details( ): $mol_view
		version_rows( ): readonly(any)[]
		Versions( ): $mol_view
		version_arg( id: any): Record<string, any>
		version_uri( id: any): string
		version_link_current( id: any): boolean
		version_title( id: any): string
		version_mode_rows( ): readonly(any)[]
		Version_modes( ): $mol_view
		version_content( ): readonly(any)[]
		version_result_arg( ): Record<string, any>
		version_result_current( ): boolean
		version_benchmarks_arg( ): Record<string, any>
		version_benchmarks_current( ): boolean
		version_changes_current( ): boolean
		version_release_notes( ): any
		version_session_arg( id: any): Record<string, any>
		version_session_current( id: any): boolean
		version_session_title( id: any): string
		version_selected_date( ): string
		Version_date( ): $mol_text
		version_action_rows( ): readonly(any)[]
		Version_actions( ): $mol_view
		version_stages_section_rows( ): readonly(any)[]
		Version_stages_section( ): $mol_view
		Requirements_title( ): $mol_view
		version_selected_requirements( ): string
		Version_requirements( ): $mol_text
		Requirements_section( ): $mol_view
		Changes_title( ): $mol_view
		change_rows( ): readonly(any)[]
		Changes( ): $mol_list
		Changes_section( ): $mol_view
		version_tests_title( ): string
		Tests_title( ): $mol_view
		version_test_rows( ): readonly(any)[]
		Version_tests( ): $mol_list
		Tests_section( ): $mol_view
		Other_artifacts_title( ): $mol_view
		other_artifact_rows( ): readonly(any)[]
		Other_artifacts( ): $mol_list
		Other_artifacts_section( ): $mol_view
		version_stage_rows( ): readonly(any)[]
		version_session_rows( ): readonly(any)[]
		version_benchmarks_panel_rows( ): readonly(any)[]
		Version_benchmark_chart_title( ): $mol_view
		Version_benchmark_lines_icon( ): $mol_icon_chart_line
		version_benchmark_lines_title( ): string
		version_benchmark_line_ids( ): readonly(any)[]
		version_benchmark_lines_selected( next?: readonly(any)[] ): readonly(any)[]
		version_benchmark_line_title( id: any): string
		Version_benchmark_line_select( ): $shm_check_list_only
		Version_benchmark_lines( ): $mol_pick
		Version_benchmark_chart_head( ): $mol_view
		version_benchmark_chart_option( ): Record<string, any>
		Version_benchmark_chart( ): $shm_echarts
		Version_benchmark_chart_frame( ): $mol_view
		Version_benchmark_legend_title( ): $mol_view
		version_benchmark_legend_rows( ): readonly(any)[]
		Version_benchmark_legend_list( ): $mol_list
		version_benchmark_dimension_title( ): string
		Version_benchmark_file_filters_title( ): $mol_view
		version_benchmark_file_ids( ): readonly(any)[]
		version_benchmark_files_selected( next?: readonly(any)[] ): readonly(any)[]
		version_benchmark_file_title( id: any): string
		Version_benchmark_files( ): $shm_check_list_only
		version_benchmark_legend_item_title( id: any): string
		Version_benchmark_legend_item_title( id: any): $mol_view
		version_benchmark_legend_item_description( id: any): string
		Version_benchmark_legend_item_description( id: any): $mol_view
		version_benchmark_info( ): string
		version_benchmark_run( next?: any ): any
		version_benchmark_status( ): string
		version_benchmark_status_color( ): string
		version_session_prerelease( id: any): boolean
		version_session_version( ): string
		release_allowed( ): boolean
		release_make( next?: any ): any
		prerelease_allowed( ): boolean
		prerelease_activate( next?: any ): any
		version_release_status( ): string
		version_release_status_color( ): string
		change_content( id: any): readonly(any)[]
		change_title( id: any): string
		change_description( id: any): string
		change_screenshot_rows( id: any): readonly(any)[]
		change_screenshot_uri( id: any): string
		version_test_uri( id: any): string
		version_test_status( id: any): string
		version_test_status_color( id: any): string
		Version_test_status( id: any): $mol_view
		version_test_title( id: any): string
		Version_test_title( id: any): $mol_view
		version_benchmark_rows( ): readonly(any)[]
		Version_benchmark_tables( ): $mol_list
		no_benchmarks_title( ): string
		version_benchmark_title( id: any): string
		Version_benchmark_title( id: any): $mol_view
		version_benchmark_table_header_cells( id: any): readonly(any)[]
		Version_benchmark_table_header( id: any): $mol_view
		Version_benchmark_table_head( id: any): $mol_view
		version_benchmark_table_body_rows( id: any): readonly(any)[]
		Version_benchmark_table_body( id: any): $mol_view
		Version_benchmark_table( id: any): $mol_view
		Version_benchmark_table_scroll( id: any): $mol_scroll
		version_benchmark_table_header_cell_text( id: any): string
		version_benchmark_table_row_cells( id: any): readonly(any)[]
		version_benchmark_table_cell_text( id: any): string
		version_benchmark_table_cell_change( id: any): string
		version_benchmark_table_cell_difference_text( id: any): string
		Version_benchmark_table_cell_difference( id: any): $mol_view
		other_artifact_uri( id: any): string
		other_artifact_title( id: any): string
		project_id( ): string
		pages( ): ReturnType< $shm_projects_page['project_pages'] >
		Menu_page( ): $mol_page
		Menu_title( ): $mol_string_button
		Project_actions( ): $shm_service_task_menu
		Version_label( ): $mol_text
		Section_link( id: any): $mol_link
		Product_page( ): $mol_page
		Configuration( ): $shm_projects_configuration
		Draft_page( ): $mol_page
		Tasks( ): $shm_projects_tasks
		Sessions( ): $shm_projects_codex_chat
		Release_stage( id: any): $mol_view
		Docs( ): $shm_projects_docs
		Modules_page( ): $mol_page
		Module_link( id: any): $mol_link
		Module_empty( ): $mol_view
		Module_page( ): $mol_page
		Dependencies_page( ): $mol_page
		Dependency_link( id: any): $mol_link
		Dependency_empty( ): $mol_view
		Dependency_page( ): $mol_page
		Project_tests( ): $shm_projects_tests
		History_page( ): $mol_page
		Version_link( id: any): $mol_link
		Version_page( ): $mol_page
		Version_result_mode( ): $mol_link
		Version_benchmarks_mode( ): $mol_link
		Version_changes_mode( ): $mol_link
		Version_changes( ): $shm_projects_release_notes_view
		Version_session_mode( id: any): $mol_link
		Version_details( ): $mol_view
		Version_stages_title( ): $mol_view
		Version_stage_list( ): $mol_list
		Version_session( ): $mol_view
		Version_benchmarks_panel( ): $mol_view
		Version_benchmark_chart_section( ): $mol_view
		Version_benchmark_legend( ): $mol_view
		Version_benchmark_file_filters( ): $mol_view
		Version_benchmark_legend_item( id: any): $mol_view
		Version_benchmark_info( ): $mol_text
		Version_benchmark_run( ): $mol_button_major
		Version_benchmark_status( ): $mol_text
		version_session_run( ): any
		version_session_iteration( id: any): number
		Version_session_chat( id: any): $shm_projects_goal_chat
		Version_release( ): $mol_button_major
		Version_prerelease( ): $mol_button_major
		Version_release_state( ): $mol_text
		Change( id: any): $mol_view
		Change_title( id: any): $mol_view
		Change_description( id: any): $mol_text
		Change_screenshots( id: any): $mol_view
		Change_screenshot( id: any): $shm_projects_image_viewer
		Version_test( id: any): $mol_link
		Version_benchmarks( ): $mol_view
		No_benchmarks( ): $mol_view
		Version_benchmark( id: any): $mol_view
		Version_benchmark_table_header_cell( id: any): $mol_view
		Version_benchmark_table_row( id: any): $mol_view
		Version_benchmark_table_cell( id: any): $mol_view
		Other_artifact( id: any): $mol_link
		No_other_artifacts( ): $mol_view
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map